// extracted by mini-css-extract-plugin
export default {"colorWrapper":"ColorWrapper_colorWrapper__WSg4d","colorWrapper__mobile":"ColorWrapper_colorWrapper__mobile__NgBcw"};